export default "__VITE_ASSET__7991937a__"